import { CheckCircle2 } from 'lucide-react';
import { allRoleConfigs } from '../../../../../data/roleManagement/roleManagementData';

const RoleSelectionCards = ({ role, setRole, isSubadmin }) => {
  const availableRoles = isSubadmin
    ? allRoleConfigs.filter((r) => r.value === 'bookings' || r.value === 'operations')
    : allRoleConfigs;

  return (
    <div className="space-y-3">
      <label className="block text-xs font-bold text-slate-700 tracking-wide mb-1.5 ml-1">
        Select Role & Permissions <span className="text-rose-500">*</span>
      </label>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3.5">
        {availableRoles.map((roleOption) => {
          const Icon = roleOption.icon;
          const isSelected = role === roleOption.value;
          return (
            <div
              key={roleOption.value}
              onClick={() => setRole(roleOption.value)}
              className={`border-2 rounded-2xl p-4 cursor-pointer transition-all ${
                isSelected
                  ? 'border-[#067978] bg-[#067978]/5 ring-4 ring-[#067978]/10'
                  : 'border-gray-100 hover:border-gray-200 bg-white'
              }`}
            >
              <div className="flex items-start justify-between mb-2">
                <div className="flex items-center gap-2.5">
                  <div className={`w-8 h-8 rounded-xl flex items-center justify-center border ${roleOption.color}`}>
                    <Icon size={16} />
                  </div>
                  <div>
                    <h3 className="font-bold text-sm text-gray-900">{roleOption.title}</h3>
                    <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider">{roleOption.badge}</span>
                  </div>
                </div>
                {isSelected && (
                  <CheckCircle2 size={18} className="text-[#067978]" />
                )}
              </div>
              <p className="text-xs text-gray-500 font-medium leading-relaxed mt-2">
                {roleOption.description}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RoleSelectionCards;
